(function(){
  'use strict';
  var hero=document.getElementById('posMainHero');
  if(!hero||hero.dataset.heroReady)return;
  hero.dataset.heroReady='true';
  var slides=Array.from(hero.querySelectorAll('[data-hero-slide]'));
  var controls=hero.querySelector('.pos-hero-controls');
  if(slides.length<2||!controls)return;
  var dots=Array.from(hero.querySelectorAll('[data-hero-go]'));
  var pause=hero.querySelector('[data-hero-pause]');
  var status=hero.querySelector('.pos-hero-status');
  var motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  var backgroundVideos=Array.from(hero.querySelectorAll('.pos-hero-background-video'));
  function syncVideo(){
    hero.dataset.motionPaused=String(userPaused||motion.matches||document.hidden||!inView);

    backgroundVideos.forEach(function(video){
      var active=video.closest('[data-hero-slide]').classList.contains('is-active');
      if(active&&!motion.matches&&!document.hidden&&inView&&(!video.classList.contains('pos-learning-video')||!userPaused)){
        if(video.dataset.src&&!video.getAttribute('src')){video.src=video.dataset.src;video.load();}
        video.muted=true;var playback=video.play();
        if(playback&&playback.catch)playback.catch(function(){video.classList.remove('is-playing');});
      }else{video.pause();video.classList.remove('is-playing');}
    });
  }
  backgroundVideos.forEach(function(video){
    video.defaultMuted=true;
    video.addEventListener('playing',function(){video.classList.add('is-playing');});
    video.addEventListener('error',function(){video.classList.remove('is-playing');});
  });
  var index=0,timer=null,userPaused=false,manualSelected=false,hovered=false,focused=false,inView=true;
  hero.querySelectorAll('[data-hero-video]').forEach(function(button){button.addEventListener('click',function(){
    var playerRoot=document.getElementById('posImmersiveVideo');if(!playerRoot)return;
    userPaused=true;cancelTimer();updatePause();backgroundVideos.forEach(function(v){v.pause();});
    playerRoot.dataset.pendingHeroVideo=button.dataset.heroVideo;
    playerRoot.dispatchEvent(new CustomEvent('pos:play-project-video',{detail:{index:Number(button.dataset.heroVideo)}}));
    playerRoot.scrollIntoView({behavior:'instant',block:'center'});
    var player=document.getElementById('posImmersivePlayer');if(player)player.focus({preventScroll:true});
  });});

  function cancelTimer(){if(timer!==null){clearTimeout(timer);timer=null;}}
  function schedule(){
    cancelTimer();
    if(userPaused||manualSelected||motion.matches||hovered||focused||document.hidden||!inView)return;
    timer=setTimeout(function(){show(index+1,false);},slides[index].classList.contains('pos-learning-slide')?15000:index===0?14000:7500);
  }
  function updatePause(){
    var paused=userPaused||motion.matches;
    pause.hidden=motion.matches;
    pause.textContent=paused?'Play':'Pause';
    pause.setAttribute('aria-label',paused?'Play hero slideshow':'Pause hero slideshow');
    status.setAttribute('aria-live',paused?'polite':'off');
  }
  function show(next,manual){
    if(manual)manualSelected=true;
    index=(next+slides.length)%slides.length;
    slides.forEach(function(slide,i){
      var active=i===index;
      slide.classList.toggle('is-active',active);
      slide.setAttribute('aria-hidden',active?'false':'true');
      slide.inert=!active;
      if(active&&i===0){var firstVideo=slide.querySelector('video');if(firstVideo&&firstVideo.readyState>0)firstVideo.currentTime=0;}
      dots[i].setAttribute('aria-current',active?'true':'false');
    });
    status.textContent=(index+1)+' / '+slides.length;
    updatePause();syncVideo();schedule();
  }
  hero.querySelector('[data-hero-prev]').addEventListener('click',function(){show(index-1,true);});
  hero.querySelector('[data-hero-next]').addEventListener('click',function(){show(index+1,true);});
  dots.forEach(function(dot){dot.addEventListener('click',function(){show(Number(dot.dataset.heroGo),true);});});
  pause.addEventListener('click',function(){
    userPaused=!userPaused;if(!userPaused)manualSelected=false;updatePause();syncVideo();schedule();
  });
  hero.addEventListener('mouseenter',function(){hovered=true;schedule();});
  hero.addEventListener('mouseleave',function(){hovered=false;schedule();});
  hero.addEventListener('focusin',function(){focused=true;schedule();});
  hero.addEventListener('focusout',function(event){if(!hero.contains(event.relatedTarget)){focused=false;schedule();}});
  document.addEventListener('visibilitychange',function(){syncVideo();schedule();});
  if(motion.addEventListener)motion.addEventListener('change',function(){updatePause();syncVideo();schedule();});
  if('IntersectionObserver' in window){new IntersectionObserver(function(entries){inView=entries[0].isIntersecting;syncVideo();schedule();},{threshold:.1}).observe(hero);}
  slides.slice(1).forEach(function(slide){var image=slide.querySelector('.photo-scene img');if(image)image.loading='eager';});
  controls.hidden=false;show(location.hash==='#posLearningHero'?3:0,false);
})();


